import React from 'react';
import COHeadline from '@components/framework/headlines/COHeadline.tsx';
import RingilButton from '@components/ringil3/Buttons/RingilButton.tsx';
import SvgPencil from '@icons/pencil-inverted.svg?react';
import SecuredArea from '@components/security/SecuredArea';
import { SecuredConfig } from '@components/security/securedDecoration';

interface ComponentProps {
  icon?: JSX.Element;
  title: string;
  // Deprecated: prefer `secured`. Kept optional while call sites migrate to security flags.
  editable?: boolean;
  onEditClick?: () => void;
  titleVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
  secured?: SecuredConfig;
}

const EditableHeading3: React.FC<ComponentProps> = ({ title, icon, editable, onEditClick = () => {}, titleVariant = 'h3', secured }) => {
  const editButton = (
    <RingilButton
      mode={'table'}
      icon={<SvgPencil />}
      onClick={() => {
        onEditClick();
      }}
    />
  );
  return (
    <div className="flex items-center gap-[0.4rem] justify-between">
      <div className="flex gap-2 items-center min-h-[2rem]">
        <COHeadline title={title} variant={titleVariant}
                    icon={icon} />
      </div>
      {secured ? (
        <SecuredArea {...secured}>{editButton}</SecuredArea>
      ) : (
        <SecuredArea
          id={`editable-heading-${title}`}
          label={title}
          visible={[{ type: 'data', label: 'editable', satisfied: !!editable }]}
        >
          {editButton}
        </SecuredArea>
      )}
    </div>
  );
};

export default EditableHeading3;
